export const save_OLD_AGEData = (age) => {
    return {
        type: 'CHANGE_OLD_AGE_DATA',
        old_age: age,
    }
};

export const saveStep = () => {
    return {
        type: 'CHANGE_STEP_DATA',
        step: 4,
    }
};

export const save_Pref_Fans = (value) => {

  if (value == 5) {
    return {
        type: 'CHANGE_HER_PREF_FANS',
        pref_fans: 1,
    }
  } else {
    return {
        type: 'CHANGE_HER_PREF_FANS',
        pref_fans: 0,
    }
  }
};

export const savePopCount = (value) => {
    return {
        type: 'CHANGE_FOURTH_POP_COUNT',
        payload: value,
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/scenes/Question4/actions.js